import appPaths from "../router/app.paths";
export default () => {
  return {
    menu: [
      {
        text: "",
        key: "",
        items: [
          {
            key: "menu.dashboard",
            text: "Dashboard",
            link: "/dashboard",
            icon: "mdi-view-dashboard-outline",
            role: ['admin']
          },
        ],
      },
      {
        text: "Sales",
        key: "menu.sales",
        items: [
          {
            icon: "mdi-cart-outline",
            key: "menu.orders",
            text: "Orders",
            link: appPaths.orders,
            role: ['admin', 'warehouse_staff']
          },
          // {
          //   icon: "mdi-truck-outline",
          //   key: "menu.shipments",
          //   text: "Shipments",
          //   link: appPaths.shipments,
          //   role: ['admin']
          // },
          // {
          //   icon: "mdi-file-document-outline",
          //   key: "menu.invoices",
          //   text: "Invoices",
          //   link: appPaths.invoices,
          //   role: ['admin']
          // },
          // {
          //   icon: "mdi-cash-multiple",
          //   key: "menu.transactions",
          //   text: "Transactions",
          //   link: appPaths.transactions,
          //   role: ['admin']
          // },
        ]
      },


      {
        text: "Catalog",
        key: "menu.catalog",
        items: [
          {
            icon: "mdi-cube-outline",
            key: "menu.products",
            text: "Products",
            link: appPaths.products,
            role: ['admin', 'warehouse_staff']
          },
          {
            icon: "mdi-shape-outline",
            key: "menu.categories",
            text: "Categories",
            link: appPaths.categories,
            role: ['admin']
          },
          {
            icon: "mdi-pine-tree",
            key: "menu.woods",
            text: "Woods",
            link: appPaths.woods,
            role: ['admin']
          },
          {
            icon: "mdi-warehouse",
            key: "menu.warehouses",
            text: "Warehouses",
            link: appPaths.warehouses,
            role: ['admin']
          },
        ]
      },

      {
        text: "Settings",
        key: "menu.settings",
        items: [
          {
            icon: "mdi-cog-outline",
            key: "menu.general",
            text: "General",
            link: appPaths.settingsGeneral,
            role: ['admin']
          },
          {
            icon: "mdi-account-cog-outline",
            key: "menu.users",
            text: "Users",
            link: appPaths.settingsUsers,
            role: ['admin']
          },
        ]
      }

    ],
  };


}
